import jQuery from "jquery";
(function (far, $) {
  far.toggle = {};

  //#region Public functions ====================================================

  far.toggle.initialize = function () {
    wireToggleOpen();
    wireToggleClass();
    wireToggleSelf();

    window.callbackUpdateToggleClicks = far.toggle.updateToggleClicks;

    $(document).on("click", function () {
      $(".open").removeClass("open");
    });
  };

  far.toggle.updateClick = function (element) {
    addClickEvent(element);
  };

  far.toggle.updateClicksInParent = function (element) {
    element.find(".js-toggle").each(function () {
      var self = $(this);
      addClickEvent(self);
    });
  };

  far.toggle.updateToggleClicks = function (element) {
    element.find(".js-toggle-class").each(function () {
      addToggleClassClickEvent($(this));
    });
  };

  //#endregion

  //#region Private functions ===================================================

  function addClickEvent(self) {
    var e = self.data("element");

    if (!e) {
      e = self;
    } else {
      e = e === "parent" ? self.parent() : $(e);
    }

    e.parent()
      .unbind("click.toggle2")
      .on("click.toggle2", function (event) {
        event.stopPropagation();
      });

    self.unbind("click.toggle").bind("click.toggle", function (event) {
      event.stopPropagation();
      event.preventDefault();

      $(".open").not(e).removeClass("open");
      e.toggleClass("open");
    });
  }

  function addToggleClassClickEvent(self) {
    self.click(function (e) {
      e.preventDefault();

      var $element = $(this);
      var cssClass = $element.data("class");
      var parent = $element.data("parent");
      var target = $element.data("target");

      $element.closest(parent).find(target).toggleClass(cssClass);
    });
  }

  function addToggleSelfClickEvent(self) {
    self.click(function (e) {
      e.preventDefault();

      var $element = $(this);
      var cssClass = $element.data("selfclass");

      $element.toggleClass(cssClass);
    });
  }

  function wireToggleOpen() {
    $(".js-toggle").each(function () {
      addClickEvent($(this));
    });
  }

  function wireToggleClass() {
    $(".js-toggle-class").each(function () {
      addToggleClassClickEvent($(this));
    });
  }

  function wireToggleSelf() {
    $(".js-toggle-self").each(function () {
      addToggleSelfClickEvent($(this));
    });
  }

  //#endregion
})(window.far || (window.far = {}), jQuery);
